<app-intermission
  *ngIf="showIntermission && !showTimer"
  [label]="intermissionButtonLabel"
  (onContinue)="stopIntermission()"
></app-intermission>

<div
  *ngIf="showTimer"
  class="app-container app-flex app-flex-middle flex-column"
>
  <div
    class="
      app-word-display
      d-flex
      flex-column
      align-items-center
      justify-content-center
    "
  >
    <p style="font-size: 500%">{{ timer }}</p>
  </div>
</div>

<div
  *ngIf="!showIntermission && !showTimer"
  class="
    app-container
    vw-100
    vh-100
    d-flex
    align-items-center
    justify-content-center
  "
>
  <div *ngIf="!isVisible">
    <svg
      class="app-focus-marker"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      />
    </svg>

    <app-button-navigation
      [type]="type"
      [readingMode]="mode === 'reading'"
    ></app-button-navigation>
  </div>

  <div
    *ngIf="isVisible"
    class="d-flex align-items-center justify-content-center"
  >
    <div
      class="
        app-word-display
        d-flex
        flex-column
        align-items-center
        justify-content-center
      "
      *ngIf="!finishedTrial"
    >
      <!-- ngFor is needed in order to show the fade out for every word -->
      <div class="app-word-container" *ngIf="mode !== 'reading' && primer">
        <div
          class="app-priming-primer"
          *ngFor="let need of [stimuli[id]]"
          [ngClass]="{ visible: isVisible, invisible: !isVisible }"
          [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
        >
          {{ displayPrimer | uppercase }}
        </div>
      </div>
      <div
        class="app-word-container"
        *ngIf="mode !== 'reading' && primer_blank"
      >
        <div
          *ngFor="let need of [stimuli[id]]"
          [ngClass]="{ visible: isVisible, invisible: !isVisible }"
          [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
        ></div>
      </div>
      <div
        class="app-word-container"
        *ngIf="mode !== 'reading' && target && !primer && !primer_blank"
      >
        <div
          *ngFor="let need of [stimuli[id]]"
          [ngClass]="{ visible: isVisible, invisible: !isVisible }"
          [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
          (onKeypress)="checkAnswerAndLoadNextItem($event)"
        >
          {{ displayValue | lowercase }}
        </div>
      </div>
      <div
        class="app-word-container"
        *ngIf="mode !== 'reading' && target_blank && !primer && !primer_blank"
      >
        <div
          *ngFor="let need of [stimuli[id]]"
          [ngClass]="{ visible: isVisible, invisible: !isVisible }"
          [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
          (onKeypress)="checkAnswerAndLoadNextItem($event)"
        ></div>
      </div>

      <div class="app-word-container" *ngIf="mode === 'reading'">
        <div
          *ngFor="let need of [stimuli[id]]"
          [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
          (onKeypress)="checkAnswerAndLoadNextItem($event)"
        >
          {{ displayText }}
        </div>
      </div>
    </div>

    <app-button-navigation
      [type]="type"
      [readingMode]="mode === 'reading'"
    ></app-button-navigation>
  </div>
</div>
